export const VARIABLE_TYPE = {
  LIST: 'LIST',
  RANGE: 'RANGE',
};
